/* contexto.tsx ----------------------------------------------------------- */
"use client";

import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface ContextoCursorType<T = any> {
  /** dados exibidos pelo cursor */
  hoveredData: T | null;
  /** define (ou atualiza) os dados do cursor               */
  setHoveredData: Dispatch<SetStateAction<T | null>>;
  /** zera o cursor de forma explícita                      */
  clearHoveredData: () => void;
}

const ContextoCursor = createContext<ContextoCursorType | undefined>(undefined);

/** hook de consumo */
export const useCursor = <T,>() => {
  const ctx = useContext(ContextoCursor) as ContextoCursorType<T>;
  if (!ctx) console.log("useCursor deve ser usado dentro de CursorProvider");
  return ctx;
};

/** provider */
export function CursorProvider({ children }: { children: ReactNode }) {
  const [hoveredData, setHoveredData] = useState<any | null>(null);

  const clearHoveredData = () => setHoveredData(null);

  return (
    <ContextoCursor.Provider
      value={{ hoveredData, setHoveredData, clearHoveredData }}
    >
      {children}
    </ContextoCursor.Provider>
  );
}
